const NAME = "FAMILY_ASIGNATIONS";

export default NAME;
